import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Space, Tag } from 'antd';
import LanguageDropdown from './LanguageDropdown';
import AvatarDropdown from './AvatarDropdown';
import store from '@/stores';

const RightContent = observer(() => {
  return (
    <div className="global-right-content">
      <Space size={0} style={{ display: 'flex' }}>
        <Tag color="purple">VER - {process.env.REACT_APP_VERSION}</Tag>
        <AvatarDropdown store={store} />
        <LanguageDropdown store={store} />
      </Space>
    </div>
  );
});

export default RightContent;
